import { Row, Col } from 'react-bootstrap';
import {
  SubSectionHeading,
  HeadingDesc,
  SectionHeadingSmall
} from '../../../Components/Headings';
import SimpleCard from '../../../Components/Card/simpleCard/SimpleCard';
import SectionWithTwoCards from '../../../Components/sectionsWithTwoCards/SectionWithTwoCards';
import { RightArrowWithBorder } from '../../../Components/icons';
import { AnchorLink } from '../../../Components/button';
import img1 from '../../../assets/images/png/health_measure.png';
import img2 from '../../../assets/images/png/bp_image3.png';
import './monitorhealthSection.css';

function MonitorHealthSection() {
  return (
    <div className="monitorHealthSection">
      <SectionWithTwoCards
        secTopContent={<SectionTopContent />}
        rightCardContent={<RightCardContent />}
        leftCardContent={<LeftCardContent />}
      />
    </div>
  );
}

function SectionTopContent() {
  return (
    <>
      <SubSectionHeading text="Monitor your health in real-time" />
      <HeadingDesc text="Our artificial intelligence algorithms work with any phone or laptop camera to accurately measure your vitals in under 2 minutes." />
    </>
  );
}

function RightCardContent() {
  return (
    <SimpleCard bgColor="#FDEDF1">
      <Row>
        <Col md={6} className="order-lg-1 order-2">
          <div className="bp_image_box">
            <img src={img2} className="bp_image3" alt="health_measure" />
          </div>
        </Col>
        <Col md={6} className="order-lg-2 order-1">
          <div className="content_container">
            <SectionHeadingSmall
              text="How Do We Extract Health Measurements?"
              color="#EF6286"
            />
            <HeadingDesc text="Meri Sehat extracts health measurements from a video stream of exposed skin on the surface of a human face." />
            <div className="btn_container">
              <RightArrowWithBorder />
              <AnchorLink text="learn more" />
            </div>
          </div>
        </Col>
      </Row>
    </SimpleCard>
  );
}

function LeftCardContent() {
  return (
    <SimpleCard bgColor="#BEF5F1">
      <Row>
        <Col md={6}>
          <div className="content_container">
            <SectionHeadingSmall
              text="How Do We Extract Health Measurements?"
              color="#29BCC1"
            />
            <HeadingDesc text="Meri Sehat extracts health measurements from a video stream of exposed skin on the surface of a human face." />
            <div className="btn_container">
              <RightArrowWithBorder />
              <AnchorLink text="learn more" />
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className="text-lg-end text-center">
            <img src={img1} className="health_measure" alt="health_measure" />
          </div>
        </Col>
      </Row>
    </SimpleCard>
  );
}

export default MonitorHealthSection;
